<!-- eslint-disable -->
<template lang="pug">
    .row.course-preview
        .col-xs-10.course-preview__column.course-preview__column.course-preview__column_hide-name
            .course-preview__item
                svg-icon.course-preview__icon(name="book", size="x-large")
                router-link.course-preview__info.course-preview__info_large.course-preview__link.course-preview__link_large(
                    :to="{name: 'course:profile', params: {id: profile.id}}"
                )
                    | {{ profile.name }}
        .col-xs-2.col-sm-1.last-sm.course-preview__column.end-xs
            div
                dropdown(:icon="false" :is-last="isLast" without-move)
                    template(slot="link")
                        svg-icon.course-preview__icon.course-preview__icon_blue(name="select", :size="selectorSize")
                    ul.dropdown__links
                        li.dropdown__link
                            router-link.course-preview__link(:to="{name: 'course:profile', params: {id: profile.id}}")
                                | {{ $i18n.t('list.list_common_actionsOpen') }}
                        li.dropdown__link(v-if="isShowLink")
                            router-link.course-preview__link(:to="{name: 'course:edit', params: {id: profile.id}}")
                                | {{ $i18n.t('list.list_common_actionsEdit') }}
                        li.dropdown__link(v-if="isShowLink")
                            a(
                                href="javascript://"
                                @click="changeStatus"
                                v-if="profile.status === 'active'"
                            )
                                | {{ $i18n.t('list.list_common_actionsArchive') }}
                            a(
                                href="javascript://"
                                @click="changeStatus"
                                v-else
                            )
                                | {{ $i18n.t('list.list_common_actionsRestore') }}
                        li.dropdown__link(v-if="isShowLink")
                            a(
                                href="javascript://"
                                @click="displayConfirmDeleteModal = true"
                            )
                                | {{ $i18n.t('list.list_common_actionsDelete') }}

        .col-xs-12.col-sm-11.course-preview__column
            .course-preview__name.hidden-xs
                svg-icon.course-preview__icon(name="book", size="x-large")
                router-link.course-preview__info.course-preview__info_large.course-preview__link.course-preview__link_large(
                    :to="{name: 'course:profile', params: {id: profile.id}}"
                )
                    | {{ profile.name }}
            .course-preview__items
                .course-preview__item
                    template(v-if="profile.status === 'active'")
                        svg-icon.course-preview__icon(name="check")
                        .course-preview__info {{ $i18n.t('common.common_status_active') }}
                    template(v-else)
                        svg-icon.course-preview__icon(name="cancel")
                        .course-preview__info {{ $i18n.t('common.common_status_archived') }}
                .course-preview__item(v-if="user.isSuperadmin || user.isManagerOrSupport")
                    svg-icon.course-preview__icon(name="profile", size="base")
                    .course-preview__info {{ amountOfStudents }}
                .course-preview__item(v-if="user.isSuperadmin || user.isManagerOrSupport")
                    svg-icon.course-preview__icon(name="list-inverse", size="base")
                    .course-preview__info {{ amountOfGrades }}
        confirm-delete-modal(
            v-if="displayConfirmDeleteModal"
            @close="displayConfirmDeleteModal = false"
            @delete="$emit('delete', profile.id)"
        )
            |  {{ " " + $i18n.t('list.list_course_deleteCourseModal') }}
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../elements/Dropdown.vue';
    import CourseApi from '../../../api/course';
    import {mapState} from 'vuex';
    import ConfirmDeleteModal from '../../../modals/ConfirmDeleteModal.vue';

    export default {
        props: {
            profile: Object,
            isLast: Boolean
        },
        data() {
            return {
                displayConfirmDeleteModal: false
            }
        },
        components: {
            Dropdown,
            ConfirmDeleteModal
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            amountOfStudents () {
                return this.profile.amountOfStudents + ' '
                        + this.$i18n.tc('profiles.profiles_user_studentsDeclension', this.profile.amountOfStudents)
            },
            amountOfGrades () {
                return this.profile.amountOfGrades + ' '
                        + this.$i18n.tc('list.list_course_classDeclination', this.profile.amountOfGrades)
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            },
            isShowLink () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        },
        methods: {
            changeStatus() {
                if (this.profile.status === 'archived') {
                    this.profile.status = 'active';
                } else {
                    this.profile.status = 'archived';
                }
                CourseApi.update(this.profile.id, this.profile)
            }
        }
    }
</script>


<style lang="scss" scoped>
    .course-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .course-preview__column {
        padding: 0;
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }


    .course-preview__column:last-child {
        margin-bottom: 0;
    }

    .course-preview__column:first-child {
        margin-bottom: 16px;
    }


    .course-preview__column_hide-name {
        @include media($sm) {
            display: none;
        }
    }

    .course-preview__name {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
    }

    .course-preview__items {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: -8px 0;
    }


    .course-preview__icon {
        color: $hsl-color-green-58;
    }

    .course-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .course-preview__item {
        display: flex;
        align-items: center;

        padding: 8px 0;

        font-size: 13px;
        line-height: 16px;
        font-weight: normal;
    }

    .course-preview__item:not(:last-child) {
        margin-right: 16px;
    }

    .course-preview__info {
        margin-left: 8px;
    }

    .course-preview__info_large {
        margin-left: 16px;
    }

    .course-preview__link {
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .course-preview__link_large {
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .custom-dropdown {
        top: 0;
        left: 0;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }
</style>
